import styled from 'styled-components/macro'

import { transparentize } from 'polished'

export const TokenListWrap = styled.div`
  position: absolute;
  top: calc(100% + 0.3rem);
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 15.4rem;
  background-color: ${(props) => props.theme.color.elementBgSecond};
  border: 0.1rem solid ${(props) => props.theme.color.elementBorderSecond};
  border-radius: 0.8rem;
  overflow: hidden;
  z-index: ${(props) => props.theme.zIndex.preloader};
`

export const TokenListContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
`

export const TokenListLoader = styled.div`
  padding: 0.6rem 1.6rem;
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const TokenListLoaderText = styled.span`
  padding: 1.2rem 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.3rem;
  line-height: 1.2;
  letter-spacing: normal;
  color: ${(props) => props.theme.color.textPrimary};
`

export const TokenRowElem = styled.button`
  padding: 0.8rem 1.6rem;
  width: 100%;

  font-family: ${(props) => props.theme.font.family.default};
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${(props) => props.theme.color.textPrimary};
  background-color: ${(props) => props.theme.color.transparent};
  border: none;
  transition: all 0.26s ease;
  cursor: pointer;

  &:disabled {
    opacity: ${(props) => props.theme.opacity.opacity05};
  }

  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    background-color: ${(props) => transparentize(0.8, props.theme.color.elementBg)};
  }

  &:hover:not([disabled]),
  &:active:not([disabled]) {
    color: ${(props) => props.theme.color.textHint};
  }
`

export const Divider = styled.span`
  margin: 0 0.6rem;
`

export const TokenElement = styled.span<{ type?: string }>`
  padding: 0;
`
